let apiUrl;
let webUrl;
let environment;
let cuUrl = 'https://www.claveunica.gob.cl';

const hostname = window && window.location && window.location.hostname;

if(hostname === 'pagos.estugira.com') {
    apiUrl = 'https://estugira.com/apipagos';
    webUrl = 'https://pagos.estugira.com';
    environment = 'PRODUCTION';
}

else {
    apiUrl = 'http://estugira-local.lazos.cl:3001';
    webUrl = 'http://estugira-local.lazos.cl:3000';
    environment = 'DEVELOPMENT';
}




export const APP_CONFIG = { apiUrl, webUrl, environment, cuUrl };
